<template>
    <transition name="modal-fade">
		<div class="modal modal-mask" style="display: block">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Delete {{ type == 'node' ? 'Decision' : 'Choice' }}</h5>
                        <button type="button" class="close" v-on:click="$emit('close')">&times;</button>
                    </div>

                    <template v-if="type == 'node'">
                        <template v-if="isTerminal">
                            <div class="modal-body">
                               <div class="prompt">
                                    This will remove this decision from the tree.
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" @click="$emit('close')">{{ lang['button.cancel'] }}</button>
                                <button type="button" class="btn btn-delete" @click="deleteItem(false)">{{ lang['button.delete'] }}</button>
                            </div>
                        </template>
                        <template v-else>
                            <div class="modal-body">
                                    This decision leads to later decisions. If you delete it, you will:
                                    <ul>
                                        <li>delete all of its associated choices</li>
                                        <li>delete all of the later decisions that are not linked to the model in other ways</li>
                                    </ul>
                                    If you don't want to lose portions of your model, use the "link choice" button to connect them before deleting this decision.
                                </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" @click="$emit('close')">{{ lang['button.cancel'] }}</button>
                                <button type="button" class="btn btn-delete" @click="deleteItem(false)">{{ lang['button.delete'] }}</button>
                                <!--<button type="button" class="btn btn-primary btn-gradient" @click="deleteItem(true)">Link Choices</button>-->
                            </div>
                        </template>
                    </template>

                    <template v-if="type == 'relation'">
                        <div  class="modal-body">
                            <div class="prompt">
                                By deleting this choice, you will be removing:
                                <br>
                                <br>
                                <ul>
                                    <li>this choice and its text</li>
                                    <li>the links to all later decisions</li>
                                    <li>all of the later decisions that are not linked to the model in other ways</li>
                                </ul>
                                Are you sure you want to delete this choice?
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click="$emit('close')">{{ lang['button.cancel'] }}</button>
                            <button type="button" class="btn btn-delete" @click="deleteItem(false)">{{ lang['button.delete'] }}</button>
                        </div>
                    </template>
				</div>
			</div>
		</div>
	</transition>


</template>

<script>
export default {
    props: ['itemData'],
    data() {
        return {
            type: '',
            isTerminal: false,
            lang: lang,
        }
    },

    mounted() {
        this.type = currentlyEditing;
        if (this.type == 'node') {
            this.isTerminal = $('.node.nodeID' + this.itemData).hasClass('terminal')
        }
    },

    methods: {
        closeModal() {
            this.name = '';
            this.$emit('close');
        },

        deleteItem(attachChildren) {
            $(".editorButton").addClass("hidden");
            switch(this.type) {
                case 'node':
                    attachChildren
                        ? attachChildrenConfirm(this.itemData)
                        : deleteDecision(this.itemData);
                    this.closeModal();
                    chosenNode = 0;
                    break;
                case 'relation':
                    deleteRelationAndChildren(this.itemData);
                    this.closeModal();
                    chosenRel = 0;
                    break;
            }
        }
    }
}
</script>
